import React, { useState, useEffect } from "react";

const AboutSection = () => {
  const [currentTech, setCurrentTech] = useState(0);
  const techHighlights = [
    "Building AI-Powered Applications",
    "Creating Intelligent User Experiences",
    "Developing RAG Systems",
    "Implementing Agentic AI Solutions",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTech((prev) => (prev + 1) % techHighlights.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="about-enhanced">
      {/* Floating Background Elements */}
      <div className="about__background">
        <div className="floating-elements">
          {/* Floating Shapes */}
          <div className="float-shape float-shape--1"></div>
          <div className="float-shape float-shape--2"></div>
          <div className="float-shape float-shape--3"></div>
          <div className="float-shape float-shape--4"></div>
          <div className="float-shape float-shape--5"></div>

          {/* Floating Tech Icons */}
          <div className="float-tech float-tech--1">⚛️</div>
          <div className="float-tech float-tech--2">🤖</div>
          <div className="float-tech float-tech--3">🧠</div>
          <div className="float-tech float-tech--4">⚡</div>
          <div className="float-tech float-tech--5">🦜</div>

          {/* Animated Particles */}
          <div className="particle particle--1"></div>
          <div className="particle particle--2"></div>
          <div className="particle particle--3"></div>
          <div className="particle particle--4"></div>
          <div className="particle particle--5"></div>
          <div className="particle particle--6"></div>
        </div>

        {/* Geometric Pattern */}
        <div className="geometric-pattern">
          <div className="pattern-grid"></div>
        </div>
      </div>

      <div className="container">
        {/* Header Section */}
        <div className="about__header-section">
          <div className="section__badge">
            <span className="badge__pulse"></span>
            <span>👋 About Me</span>
          </div>
        </div>

        {/* Main Content - Image Left, Content Right */}
        <div className="about__main-content">
          {/* Left Side - Image */}
          <div className="about__image-section">
            <div className="visual__container">
              <div className="ai__image-container">
                <div className="ai__image">
                  <div className="ai__placeholder">
                    <img
                      src="/img/ai-developer-workspace.png"
                      alt="AI Developer Workspace"
                      className="ai__main-image"
                    />
                    <div className="ai__connections">
                      <div className="connection connection--1"></div>
                      <div className="connection connection--2"></div>
                      <div className="connection connection--3"></div>
                      <div className="connection connection--4"></div>
                    </div>
                  </div>
                </div>

                {/* Floating Skill Badges */}
                <div className="floating-badges">
                  <div className="skill-badge skill-badge--1">
                    <span className="badge__icon">⚛️</span>
                    <span className="badge__text">React</span>
                  </div>
                  <div className="skill-badge skill-badge--2">
                    <span className="badge__icon">🤖</span>
                    <span className="badge__text">AI/ML</span>
                  </div>
                  <div className="skill-badge skill-badge--3">
                    <span className="badge__icon">🚀</span>
                    <span className="badge__text">Innovation</span>
                  </div>
                  <div className="skill-badge skill-badge--4">
                    <span className="badge__icon">⚡</span>
                    <span className="badge__text">Performance</span>
                  </div>
                </div>
              </div>

              {/* Dynamic Tech Highlight */}
              <div className="dynamic-tech-highlight">
                <span className="highlight-text">{techHighlights[currentTech]}</span>
              </div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="about__content-section">
            <div className="content__wrapper">
              <p className="about__description-enhanced">
                I'm a passionate Full Stack Developer with{" "}
                <span className="text--accent">7+ years</span> of experience
                building dynamic web and mobile applications with cutting-edge AI
                integration. From crafting intuitive UI/UX designs to delivering
                high-performance solutions using React.js, Node.js, React Native,
                and advanced AI technologies like{" "}
                <span className="text--accent">LangChain</span> and{" "}
                <span className="text--accent">RAG systems</span>.
              </p>

              <div className="tech__expertise">
                <h3 className="expertise__title">Core Technologies</h3>
                <div className="tech__tags">
                  <span className="tech__tag tech__tag--react">React Ecosystem</span>
                  <span className="tech__tag tech__tag--node">Node.js</span>
                  <span className="tech__tag tech__tag--mobile">React Native</span>
                  <span className="tech__tag tech__tag--ai">Agentic AI</span>
                  <span className="tech__tag tech__tag--rag">RAG Systems</span>
                  <span className="tech__tag tech__tag--langchain">LangChain</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* AI Specialization Showcase - Minimal */}
        <div className="ai__specialization-showcase">
          <div className="specialization__grid-minimal">
            <div className="spec__item-simple">
              <h4>Agentic AI</h4>
            </div>
            
            <div className="spec__item-simple">
              <h4>RAG Systems</h4>
            </div>
            
            <div className="spec__item-simple">
              <h4>LangChain</h4>
            </div>
            
            <div className="spec__item-simple">
              <h4>AI Integration</h4>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;